import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VNavigationDrawer,{attrs:{"app":"","fixed":"","temporary":""},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('div',{staticClass:"filter-menu-box"},[_c('article-filter',{ref:"articleFilter",staticClass:"mobile-filter",on:{"filtersUpdate":_vm.filtersUpdate}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }